import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DocumentService } from '@fi-app/document/document.service';
import { IParallelTasksData, parallelTasksQueue } from '@fi-shared/utils/parallel-tasks-queue';
import { DocumentGeneratePreviewService } from '@fi-app/document/document-generate-preview/document-generate-preview.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiPrintDownloadService } from '@fi-shared/fi-print-download/fi-print-download.service';
import { FiImageSize } from '@fi-shared/types';

@Component({
    selector: 'fi-word-export',
    template: `<button type="button" (click)="runExport()">{{ 'import.word_export' | fiAppText }}</button>`,
    styleUrls: ['./fi-word-export.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-word-export' },
    standalone: false,
})
export class FiWordExportComponent implements OnInit {
    constructor(
        private documentService: DocumentService,
        private documentGeneratePreviewService: DocumentGeneratePreviewService,
        private userDataService: FiUserDataService,
        private fiPrintDownloadService: FiPrintDownloadService,
    ) {}

    ngOnInit(): void {}

    runExport() {
        const languageId = this.userDataService.userData.PreferredContentLanguage;

        this.documentService.getDocumentsForExport().then((documents) => {
            let idx: number = 0;
            const url = 'MediaBank/FileUpload/DownloadGeneratedPdf';

            return new Promise<void>((resolve, reject) => {
                const requestsQueue: IParallelTasksData = parallelTasksQueue(2);
                documents.forEach((item) => {
                    const taskPromiseFn = () => {
                        const taskPromise: Promise<void> =
                            this.documentGeneratePreviewService.generateDocumentPreviewImage(
                                item,
                                languageId,
                                (documentId, previewHTML: string) => {
                                    return this.fiPrintDownloadService.downloadBinaryFile(url, {
                                        fileName: item.Name + '.pdf',
                                        size: FiImageSize.Original,
                                        data: {
                                            Source: previewHTML,
                                        },
                                    });
                                },
                            );
                        taskPromise
                            .catch(() => {
                                /*progressData.nextMessage({
                                value: `Generating preview for document ${item.Id} failed`,
                                messageType: ProgressMessageType.Error,
                            });*/
                            })
                            .finally(() => {
                                ++idx;
                                /*progressData.nextMessage({
                                value: IMPORT_END_BACKEND_WORK__PROGRESS + (100 - IMPORT_END_BACKEND_WORK__PROGRESS) * (++idx / documents.length),
                                messageType: ProgressMessageType.Percentage,
                            });*/

                                if (idx === documents.length) {
                                    window.alert('export done');
                                    resolve();
                                }
                            });
                        return taskPromise;
                    };

                    requestsQueue.add(taskPromiseFn);
                });
            });
        });
    }
}
